export const favoriteCompany = {
    favoriteCompanyList: '「{{theme}}」におけるお気に入り企業一覧'
}
